import api from "../api"

/**
 * Busca todos os contatos da empresa paginando GET /contacts/all.
 * @param {string} cFiltro - Termo de busca (query filtro).
 * @param {{ lApenasContagem?: boolean }} oOpcoes
 * @returns {Promise<{ contatos: Array, total: number, oErro: Error | null }>}
 */
const contatosTodosBuscar = async (cFiltro = "", oOpcoes = {}) => {
  if (oOpcoes.lApenasContagem) {
    const { data } = await api.get("/contacts/all", {
      params: { filtro: cFiltro, pagina: 1 },
    })
    return {
      contatos: [],
      total: data.count ?? 0,
      oErro: null,
    }
  }

  let aContatos = []
  let nPagina = 1
  let lHasMore = true
  let nTotal = 0
  let oErroParcial = null

  while (lHasMore) {
    try {
      const { data } = await api.get("/contacts/all", {
        params: { filtro: cFiltro, pagina: nPagina },
      })

      if (nPagina === 1) {
        nTotal = data.count ?? 0
      }

      aContatos.push(...(data.contacts ?? []))
      lHasMore = Boolean(data.hasMore)
      nPagina += 1
    } catch (oErro) {
      if (nPagina === 1) {
        throw oErro
      }
      oErroParcial = oErro
      break
    }
  }

  return {
    contatos: aContatos,
    total: nTotal || aContatos.length,
    oErro: oErroParcial,
  }
}

export default contatosTodosBuscar
